export class SetSearchString {
    static readonly type = "[Contacts] Set search string";

    constructor(public payload: string) {}
}
